export default "__VITE_ASSET__C$QIM77E__"